export default "__VITE_ASSET__WCjc2_km__"